<taku-form-list-main [pageTitleSuffix]="pageTitleSuffix" [_filter]="_filter" [_defaultRowValues]="_defaultRowValues">
  <div class="panel-toolbar">
    <!-- <taku-zone-switcher (onZoneChanged)="zoneChanged($event)"></taku-zone-switcher> -->
  </div>
</taku-form-list-main>
